import map from "lodash.map";
import mapvalues from "lodash.mapvalues";

const CATEGORIES = [
  "Безопасность",
  "Интеграция ИЭ",
  "Разработчики",
  "Сисадмины",
  "ТП24х7",
  "Эксплуатация банковского ПО",
  "Эмиссия",
];

const SUBCATEGORIES = {
  Безопасность: ["Заявка на доступ", "Инцидент"],
  "Интеграция ИЭ": ["Возвраты"],
  Разработчики: [
    "Bitrix24",
    "P2P переводы",
    "Pentaho",
    "WEB",
    "Акты",
    "Выплаты / сверки",
    "Изменения сайта",
    "Интернет-эквайринг",
    "Кошельки",
    "Личный кабинет агента",
    "Личный кабинет ТСП",
    "Мобильная коммерция",
    "Отчетность",
    "Подписки",
    "Посадочные страницы",
    "Расчётный банк",
    "Сайт",
    "Торговый эквайринг",
    "Управленческая отчётность",
  ],
  Сисадмины: [
    "Lotus Notes",
    "Мотив",
    "Оборудование",
    "ПО",
    "Пользователи",
    "Почта",
    "Принтеры",
    "Серверы",
    "Сеть",
    "Телефония",
  ],
  ТП24х7: [
    "Аварии, работы, сбои",
    "Внутренний звонок",
    "Другое",
    "Интернет эквайринг",
    "Карта РФИ",
    "РКО, Банк-Клиент",
    "Торговый эквайринг",
  ],
  "Эксплуатация банковского ПО": [
    "Банк-Клиент",
    "Другое",
    "Инверсия",
    "Отчетность",
    "Юнисаб",
  ],
  Эмиссия: [
    "Баланс карты",
    "Блокировка карты",
    "Другое",
    "Операции по карте",
    "Опротестование операции",
    "Разблокировка карты",
    "Смена пинкода",
  ],
};

const mappedCats = map(CATEGORIES, (c) => ({ value: c, label: c }));
const mappedSubCats = mapvalues(SUBCATEGORIES, (c) =>
  map(c, (s) => ({ value: s, label: s }))
);

export const SERVICE_DESK_CATEGORIES = mappedCats;
export const SERVICE_DESK_SUBCATEGORIES = mappedSubCats;



// WEBPACK FOOTER //
// ./src/components/ServiceDeskForm/CONSTANTS.js